<!--
 * @Descripttion: 动态卡片属性配置
 * @Author: zenghua.wang
 * @Date: 2021-09-26 17:35:55
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:04:11
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <config-field
          :data="data"
          :showType="showTypeList"
          :rename="false"
        />
        <config-filter :data="data" />
      </template>
    </api-interface>

    <!-- 卡片设置 -->
    <el-collapse-item title="卡片设置">
      <card-common :data="data" />

      <el-form-item label="背景透明">
        <el-switch
          v-model="data.option.opcity"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="背景颜色">
        <el-color-picker
          v-model="data.option.backgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示图片">
        <el-switch
          v-model="data.option.showPicture"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="标题描述反转">
        <el-switch
          v-model="data.option.reverse"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>
    </el-collapse-item>

    <el-collapse-item title="标题设置">
      <el-form-item label="字号大小">
        <el-input-number
          v-model="data.option.titleFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.titleFontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.titleColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="显示Icon">
        <el-switch
          v-model="data.option.showIcon"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <template v-if="data.option.showIcon">
        <el-form-item label="icon大小">
          <el-input-number
            v-model="data.option.iconSize"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item label="icon圆角">
          <el-input-number
            v-model="data.option.iconRadius"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item label="icon颜色">
          <el-color-picker
            v-model="data.option.iconColor"
            :predefine="predefineColors"
          />
        </el-form-item>
      </template>
    </el-collapse-item>

    <el-collapse-item title="描述设置">
      <el-form-item label="字号大小">
        <el-input-number
          v-model="data.option.textFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.textFontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.textColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="描述后缀">
        <el-input
          v-model="data.option.suffixText"
          placeholder="请输入"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 颜色设置 -->
    <config-color
      :data="data"
      :loopColor="true"
    />

    <!-- 链接 -->
    <config-link :data="data" />

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configLink from '@/dragComponents/config/common/link.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import configField from '@/dragComponents/config/common/field.vue'
import configFilter from '@/dragComponents/config/common/filter.vue'
import configColor from '@/dragComponents/config/common/color.vue'

import cardCommon from './common.vue'

export default {
  name: 'config-dynamic-card',
  components: {
    configBase,
    configLink,
    configAuth,
    configField,
    configFilter,
    configColor,
    apiInterface,
    cardCommon
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      weightList: component.weightType,
      alignList: component.alignType,
      showTypeList: [
        {
          label: '标题',
          value: 'name'
        },
        {
          label: '图片',
          value: 'picture'
        },
        {
          label: '描述',
          value: 'value'
        }
      ]
    }
  }
}
</script>
